import React, { useState } from "react";

export default function ToolTraceView({ toolCalls }) {
  if (!toolCalls || toolCalls.length === 0) {
    return <div style={s.empty}>No tool calls recorded</div>;
  }

  return (
    <div style={s.wrap}>
      {toolCalls.map((tc, i) => (
        <ToolCallCard key={i} index={i} toolCall={tc} />
      ))}
    </div>
  );
}

function ToolCallCard({ index, toolCall }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={s.card}>
      <div style={s.cardHeader} onClick={() => setExpanded(!expanded)}>
        <span style={s.index}>{index + 1}</span>
        <span style={s.toolName}>{toolCall.name}</span>
        <span style={s.argsPreview}>
          {!expanded && `(${Object.keys(toolCall.args || {}).join(", ")})`}
        </span>
        {toolCall.timestamp && (
          <span style={s.time}>
            {new Date(toolCall.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
          </span>
        )}
        <span style={s.chevron}>{expanded ? "\u25B4" : "\u25BE"}</span>
      </div>

      {expanded && (
        <div style={s.details}>
          <div style={s.section}>
            <div style={s.sectionLabel}>Arguments</div>
            <pre style={s.pre}>{JSON.stringify(toolCall.args, null, 2)}</pre>
          </div>
          <div style={s.section}>
            <div style={s.sectionLabel}>Result</div>
            <pre style={s.pre}>{JSON.stringify(toolCall.result, null, 2)}</pre>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: { display: "flex", flexDirection: "column", gap: 4 },
  empty: { color: "#999", padding: 20, textAlign: "center", fontSize: 14 },
  card: {
    border: "1px solid #e5e5e5", borderRadius: 8, overflow: "hidden",
  },
  cardHeader: {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 14px",
    cursor: "pointer", background: "#fafafa",
  },
  index: {
    width: 22, height: 22, borderRadius: 6, background: "#e5e5e5",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 11, fontWeight: 600, color: "#666", flexShrink: 0,
  },
  toolName: {
    fontSize: 13, fontWeight: 600, color: "#0f0f0f",
    fontFamily: "'SF Mono', Monaco, 'Cascadia Code', monospace",
  },
  argsPreview: { fontSize: 12, color: "#999", fontFamily: "monospace" },
  time: { fontSize: 11, color: "#bbb", marginLeft: "auto" },
  chevron: { fontSize: 10, color: "#999", marginLeft: 4 },
  details: { padding: 14, borderTop: "1px solid #e5e5e5" },
  section: { marginBottom: 12 },
  sectionLabel: {
    fontSize: 11, fontWeight: 600, color: "#999", marginBottom: 4,
    textTransform: "uppercase", letterSpacing: "0.03em",
  },
  pre: {
    background: "#fafafa", padding: 12, borderRadius: 6, fontSize: 12,
    lineHeight: 1.4, overflow: "auto", maxHeight: 200, margin: 0,
    fontFamily: "'SF Mono', Monaco, 'Cascadia Code', monospace",
    border: "1px solid #e5e5e5", color: "#333",
  },
};
